// extracted by mini-css-extract-plugin
export default {"savedList_Fav":"savedList_Fav_GqTiJa4_"};